module.exports = __webpack_public_path__ + "img/new-icon.b97c5929.svg";